import React from 'react'
import styled from 'styled-components'
import ProfileTabList from '../../data/ProfileTablist'
import { IProfileMenu, IProfileTabItem, ProfileTabState } from '../../models/IProfileMenu'
import { NavLink } from 'react-router-dom'

const ProfileTabMenu = styled.div`
  width: 100%;
  display: flex;
  list-style: none;
  margin: 1rem 0;

  li {
    margin-right: 1rem;
    font-size: 0.8rem;
  }
`

const TabLink = styled(NavLink)`
  display: block;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text3};
  font-weight: bold;
  width: fit-content;
  padding-bottom: 0.3rem;
  border-bottom: solid 1px transparent;

  &.active-tab {
    color: ${({ theme }) => theme.text1};
    border-bottom: solid 1px;
  }
`

export default function NFTProfileTabMenu(props: IProfileMenu) {
  const { onSaleList, activeTab, onCollectionList } = props

  function getCalculatingData(tabUrl: string) {
    let result: any
    switch (tabUrl) {
      case ProfileTabState.ON_SALE:
        result = onSaleList?.length
        break
      case ProfileTabState.COLLECTION:
        result = onCollectionList?.length
        break
      default:
        result = 0
    }
    return result
  }
  return (
    <ProfileTabMenu>
      {ProfileTabList.map((item: IProfileTabItem) => {
        return (
          <li key={`${item.tabUrl}_TAB_MENU`}>
            <TabLink to={`?tab=${item.tabUrl}`} className={`${activeTab === item.tabUrl ? 'active-tab' : ''}`}>
              {item.name}
              {item.noCount !== true ? ` (${getCalculatingData(item.tabUrl)})` : ''}
            </TabLink>
          </li>
        )
      })}
    </ProfileTabMenu>
  )
}
